const { Button } = require("reactstrap");

function fillerColumns(handleEdit, handleDelete) {
  return [
    {
      Header: "Filller Name",
      accessor: "name",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Phone",
      accessor: "phone",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Email",
      accessor: "email",
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => <span>{value ? value : "-"}</span>,
    },
    {
      Header: "Nozzle No",
      accessor: "Nozzel.vehicle_no",
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => (
        <span className={`badge ${value ? "bg-success" : "bg-warning"}`}>
          {value ? value : "Un Assigned"}
        </span>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => (
        <span className={`badge ${value === 1 ? "bg-success" : "bg-warning"}`}>
          {value === 1 ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      Header: "Actions",
      accessor: "actions",
      disableFilters: true,
      filterable: false,
      Cell: ({ row }) => (
        <>
          <Button
            color="primary"
            size="sm"
            onClick={() => handleEdit(row.original)}
          >
            Update
          </Button>{" "}
          <Button
            color="danger"
            size="sm"
            onClick={() => handleDelete(row.original)}
          >
            Delete
          </Button>
        </>
      ),
    },
  ];
}

export default fillerColumns;
